export const resultCategories = [
  { key: "economy", label: "经济", correct: 153, wrongIn: 23, wrongOut: 3 },
  { key: "politics", label: "政治", correct: 142, wrongIn: 18, wrongOut: 5 },
  { key: "culture", label: "文化", correct: 128, wrongIn: 12, wrongOut: 4 },
  { key: "livelihood", label: "民生", correct: 96, wrongIn: 9, wrongOut: 2 },
];

export const taggedArticles = [
  {
    id: "a1",
    category: "economy",
    title: "高效统筹疫情防控与经济社会发展",
    content:
      "落实这次重要会议的部署，各地区各部门就要在“高效”上想办法，在“统筹”上出实招，最大程度保护人民生命安全和身体健康，最大限度减少疫情对经济社会发展的影响，坚决夺取疫情防控和经济社会发展双胜利。高效不高效，关键看实效。",
    source: "人民日报",
    date: "2026/8/4",
    words: 3500,
    score: 1.5,
    archived: true,
    tags: ["经济", "民生"],
  },
  {
    id: "a2",
    category: "economy",
    title: "多地出台稳经济一揽子政策 助力企业纾困解难",
    content:
      "今年以来，各地密集出台稳经济一揽子政策措施，从减税降费、金融支持、稳岗就业等方面持续发力，帮助市场主体纾困解难，推动经济运行整体好转，为高质量发展积蓄动能。",
    source: "经济日报",
    date: "2026/8/6",
    words: 2860,
    score: 1.3,
    archived: false,
    tags: ["经济", "政策"],
  },
  {
    id: "a3",
    category: "economy",
    title: "绿色发展成为区域经济增长新引擎",
    content:
      "以生态优先、绿色发展为导向，多地加快产业结构调整，推动清洁能源、绿色制造等新兴产业集聚发展，绿色正在成为区域经济高质量发展的鲜明底色，也为经济增长注入新动能。",
    source: "新华网",
    date: "2026/8/9",
    words: 3120,
    score: 1.1,
    archived: true,
    tags: ["经济", "生态"],
  },
  {
    id: "a4",
    category: "politics",
    title: "坚持系统观念 不断提升基层治理效能",
    content:
      "基层治理是国家治理的基石。各地坚持以党建引领基层治理，健全自治、法治、德治相结合的治理体系，把党的政治优势、组织优势转化为治理效能，不断增强群众的获得感与满意度。",
    source: "人民日报",
    date: "2026/7/28",
    words: 2740,
    score: 1.42,
    archived: false,
    tags: ["政治", "治理"],
  },
  {
    id: "a5",
    category: "politics",
    title: "全面深化改革开放 激发高质量发展活力",
    content:
      "改革开放是决定当代中国命运的关键一招。要持续深化重点领域改革，稳步扩大制度型开放，以更大力度激发市场活力和社会创造力，为构建新发展格局提供坚实支撑。",
    source: "新华社",
    date: "2026/7/30",
    words: 3010,
    score: 1.28,
    archived: true,
    tags: ["政治", "改革"],
  },
  {
    id: "a6",
    category: "culture",
    title: "文化和旅游融合发展释放消费新活力",
    content:
      "以文塑旅、以旅彰文。各地深入推动文化和旅游融合发展，丰富优质产品供给，打造特色文化品牌，文旅消费潜力持续释放，成为拉动内需、促进就业的重要力量。",
    source: "光明日报",
    date: "2026/8/11",
    words: 2410,
    score: 1.36,
    archived: false,
    tags: ["文化", "旅游"],
  },
  {
    id: "a7",
    category: "culture",
    title: "让中华优秀传统文化在传承中焕发新生",
    content:
      "推动中华优秀传统文化创造性转化、创新性发展，需要让文物活起来、让典籍走出来。通过数字化手段与创新表达，传统文化正以更年轻的姿态走进大众生活。",
    source: "中国文化报",
    date: "2026/8/2",
    words: 2280,
    score: 1.21,
    archived: true,
    tags: ["文化", "传统"],
  },
  {
    id: "a8",
    category: "livelihood",
    title: "办好民生实事 持续增进群众福祉",
    content:
      "民之所盼，政之所向。各地聚焦就业、教育、医疗、养老等重点领域，用心用情用力办好民生实事，一件一件抓落实，一年接着一年干，让发展成果更多更公平惠及全体人民。",
    source: "人民网",
    date: "2026/8/7",
    words: 2650,
    score: 1.44,
    archived: true,
    tags: ["民生", "就业"],
  },
  {
    id: "a9",
    category: "livelihood",
    title: "完善社会保障体系 兜牢民生底线",
    content:
      "社会保障是保障和改善民生、维护社会公平的基本制度保障。要进一步健全覆盖全民、统筹城乡、公平统一、可持续的多层次社会保障体系，织密扎牢民生保障网。",
    source: "经济日报",
    date: "2026/8/5",
    words: 2530,
    score: 1.18,
    archived: false,
    tags: ["民生", "保障"],
  },
];